import { ReactNode, useState, useMemo, useCallback } from "react";
import ContactInfoContext, {
  IContactInfo,
  ITransactionInfo,
} from "../../contexts/ContactInfoContext";

interface IContactInfoState {
  [orgContactId: number]: IContactInfo;
}

export const ContactInfoProvider = ({ children }: { children: ReactNode }) => {
  const [contactInfo, setContactInfo] = useState<IContactInfoState>({});


  const updateContactPhoneNumbersBatch = useCallback(
    ({
      contactUpdates,
    }: {
      contactUpdates: {
        orgContactId: number;
        phoneNumbers: string[];
        transaction: ITransactionInfo;
      }[];
    }) => {
      setContactInfo((prev) => {
        const newContactInfo = { ...prev };
        
        contactUpdates.forEach(({ orgContactId, phoneNumbers, transaction }) => {
          newContactInfo[orgContactId] = {
            ...newContactInfo[orgContactId],
            phoneNumbers,
            mostRecentPhoneRequestTransaction: transaction,
            emails: newContactInfo[orgContactId]?.emails || [],
            mostRecentEmailRequestTransaction:
              newContactInfo[orgContactId]?.mostRecentEmailRequestTransaction || null,
          };
        });
        
        return newContactInfo;
      });
    },
    [],
  );

  const updateContactEmailsBatch = useCallback(
    ({
      contactUpdates,
    }: {
      contactUpdates: {
        orgContactId: number;
        emails: string[];
        transaction: ITransactionInfo;
      }[];
    }) => {
      setContactInfo((prev) => {
        const newContactInfo = { ...prev };
        
        contactUpdates.forEach(({ orgContactId, emails, transaction }) => {
          newContactInfo[orgContactId] = {
            ...newContactInfo[orgContactId],
            emails,
            mostRecentEmailRequestTransaction: transaction,
            phoneNumbers: newContactInfo[orgContactId]?.phoneNumbers || [],
            mostRecentPhoneRequestTransaction:
              newContactInfo[orgContactId]?.mostRecentPhoneRequestTransaction || null,
          };
        });
        
        return newContactInfo;
      });
    },
    [],
  );

  const getContactInfo = useCallback(
    (orgContactId: number): IContactInfo | null => {
      return contactInfo[orgContactId] || null;
    },
    [contactInfo],
  );

  const contextValue = useMemo(
    () => ({
      contactInfo,
      updateContactPhoneNumbersBatch,
      updateContactEmailsBatch,
      getContactInfo,
    }),
    [
      contactInfo,
      updateContactPhoneNumbersBatch,
      updateContactEmailsBatch,
      getContactInfo,
    ],
  );

  return (
    <ContactInfoContext.Provider value={contextValue}>
      {children}
    </ContactInfoContext.Provider>
  );
};
